module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-display-two"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemData.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.itemData.region) + " Africa"), _c('span', {
    staticClass: "highlighted"
  }, [_vm._v(_vm._s(_vm.itemData.name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-230694f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Country.vue
// module id = 682
// module chunks = 1